/* eslint-disable i18next/no-literal-string */
import { ReactComponent as BetatesLogo } from 'assets/images/general-landing/Betates.svg';
import React from 'react';
import styles from './Betates.module.scss';

export default function Betates() {
  return (
    <div className={styles.container}>
      <BetatesLogo style={{
        width: 'calc(100vw - 80px)',
        marginLeft: '40px',
        marginTop: '100px',
        marginRight: '40px',
        height: 'auto',
      }}
      />
      <div className={styles.betatesText}>
        At Betates, we offer virtual staging and image enhancement to help showcase properties. Our solutions make your listings stand out and attract buyers.
      </div>
    </div>
  );
}
